export default {
    accept_another_payment: "Тағы төлем қабылдау",
    active_plan_treatments: "Емдеудің белсенді жоспары",
    activity: "Белсенділік",
    add_complex: "Кешенді қосу",
    add_diagnosis: "Диагнозды қосу",
    add_question: "Сұрақты қосу",
    add_service: "Қызметті қосу",
    add_tooth_jaw: "Тіс / жақты қосу",
    add_visit: "Келуді қосу",
    added_by: "Кіммен қосылды",
    additional_discount: "Қосымша жеңілдік",
    age: "Жас",
    agreement: "Келісім",
    akt_of_services_for_period: "Кезең ішінде көрсетілген қызметтер актісі",
    akt_print: "Актіні басып шығару",
    allergic_reactions: "аллергиялық реакциялар",
    allergies: "Аллергиялар",
    allergy_diagnosis: "Аллергологиялық диагноз",
    anamnesis: "Стоматологиялық анамнез",
    anketa_footer: "Сауалнама футері",
    anketa_header: "Сауалнама тақырыбы",
    anketa_texts: "Сауалнама мәтіндері",
    applied: "қолданылды",
    applied_complex: "Қолданылған кешен",
    apply_to_teeth: "Тістерге қолдану",
    apply_to_whole_tooth: "Барлық тіске қолдану",
    apply_treatment_template: "Емдеу үлгісін қолдану",
    are_you_sure_to_set_plan: "Емдеу карточкасын жоспарға байланыстырғыңыз келетініне сенімдісіз бе?",
    are_you_sure_you_want_to_delete_document: " Құжатты жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_payment: " Төлемді жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_scan: " Сканды жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_status: " Статусты жойғыңыз келеді ме?",
    are_you_sure_you_want_to_delete_transaction: " Әрекетті жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_user: " Пайдаланушыны өшіргіңіз келе ме?",
    are_you_sure_you_want_to_delete_users: " Пайдаланушыларды өшіргіңіз келе ме?",
    ask_result_on_saving: " Сақтау кезінде келу нәтижесін сұрату",
    assistant: "Ассистент",
    attach_new_user: "Жаңа пайдаланушыны тіркеу",
    author: "Автор",
    available: "Қолжетімді",
    baby_teeth: "Сүт тістері",
    baby_teeth_short: "Сүт",
    balance_refill: "Депозитті толтыру",
    balance_writeoff: "Депозиттен шешіп алу",
    birthdays: "Туған күндер",
    bite: "Тістем",
    bottom_baby_teeth: "Төменгі сүт тістері",
    bottom_jaw: "Төменгі жақ",
    bottom_molars: "Төменгі түбір тістер",
    by_complexes: "Кешендер бойынша",
    by_doctors: "Дәрігерлер бойынша",
    call: "Қоңырау шалу",
    came: "Келді",
    came_from: "Қайдан келді",
    can_be_paid_with_bonuses: "Бонустармен төлеуге болады",
    can_be_written_off: "Есептен шығаруға болады",
    cancel_initiator: "Бас тарту бастамашысы",
    cancelled: "Күші жойылды",
    card: "Карточка",
    card_number: "Карточка нөмірі",
    card_transfer: "Картаға аудару",
    cash: "Қолма-қол",
    cashless: "Қолма-қол ақшасыз",
    choose_document_type_and_its_parameters: "Құжат түрін және оның параметрлерін таңдаңыз",
    choose_patient: "Пациентті таңдаңыз",
    choose_signer: "Қол қоюшыны таңдаңыз",
    choose_treatment_template: "Емдеу үлгісін таңдаңыз",
    client: "Пациент",
    client_document: "Пациент құжаты",
    client_id: "Пациент",
    client_note: "Ескертпе",
    client_service: "Клиенттік сервис",
    code: "Код",
    color: "Түс",
    combine_user_note: "Пациентті таңдап,\"біріктіру\" батырмасын басу арқылы сіз таңдалған пациенттің карточкасына сапарлар, төлемдер, диагноздар және т.б. бойынша барлық деректерді көшіре аласыз. Ағымдағы пациенттің карточкасы жойылады. Біріктіру рәсімін болдырмау мүмкін емес.",
    comment_to_phone: "Телефонға түсіндірмелер",
    comment_to_phone_2: "Қосымша телефонға түсіндірмелер",
    complaints: "Шағымдар",
    complex: "Кешен",
    complexes: "Кешендер",
    condition: "Жағдай",
    confirm_tag_deletion: "Белгіні жойғыңыз келеді ме?",
    confirmed: "Расталды",
    confirmed_male: "Расталды",
    consultation: "Консультация",
    contract: "Шарт",
    contract_agreement: "Келісім шарты",
    contract_general: "Жалпы шарт",
    contract_print: "Шартты басып шығару",
    contract_services: "Қызметтерді ұсыну шарты",
    create_diagnosis: "Диагноз жасау",
    creation_date: "Жасау күні",
    date: "Күні",
    date_add: "Жасалды",
    date_from: "күні",
    date_of_birth: "Туған күні",
    date_of_birth_month_day: "Туған күні (күні және айы)",
    date_to: "күні",
    dates_not_selected: "Күні таңдалмаған",
    debt: "қарыз",
    debt_cancellation: "Қарызды жою",
    delete_complex: "Кешенді жою",
    delete_visit: "Келуді жою",
    department_code: "Бөлімше коды",
    deposit: "Депозит",
    description: "Сипаты",
    desired_date_from: "бастап қалаған күн",
    desired_date_to: "дейін қалаған күн",
    desired_time_from: "бастап қалаған уақыт",
    desired_time_to: "дейін қалаған күн",
    detailed_information: "Толық ақпарат",
    diagnoses: "Диагноздар",
    diagnosis: "Диагноз",
    diary: "Күнделік",
    did_not_come: "Келмеді",
    discount: "Жеңілдік",
    disease_anamnez: "Ауру анамнезі (осы аурудың дамуы)",
    disease_anamnez_short: "Ауру тарихы",
    disease_development: "Осы аурудың дамуы",
    disease_history: "Ауру тарихы",
    diseases_passed_and_current: "Ауырған және ілеспе аурулар",
    doctor: "Дәрігер",
    document: "Құжат",
    document_number: "Құжат нөмірі",
    document_type: "Құжат түрі",
    does_not_participate: "Қатыспау",
    drag_file_here_or_select: "Файлды осы жерге көшіріңіз немесе таңдаңыз",
    edit_questionnaire: "Сауалнаманы өңдеу",
    electronic_cheque: "Электронды чек",
    enter_the_title: "Атауын енгізіңіз",
    epikriz: "Эпикриз",
    examination_plan: "Тексеру жоспары",
    f043: "Ф 043",
    f37u78: "037/У-88 нысаны",
    f43kaz: "043/КАЗ нысаны",
    f43rus: "043/РФ нысаны",
    f43ukr: "043/У нысаны",
    f58kaz: "058/КАЗ нысаны",
    family_account: "Отбасылық шот",
    female: "Әйел адам",
    female_short: "Әйел адам",
    fill_anamnez_from_previous_visits: "Алдыңғы келулердегі анамнезді толтыру",
    fill_balance: "Депозитті толтыру",
    filling: "Толтыру",
    finish_visit: "Қабылдауды аяқтау",
    fio: "ТАӘ",
    first_visit: "Бастапқы келу",
    fiscal_cheque: "Фискальды чек",
    for_female_patients: "Пациенттер үшін",
    formula: "Формула",
    formula_selection_instructions: "Жоғарғы көрініс: тінтуірдің сол жақ түймешігін басып тұрып, тістің қажетті жерлеріне сүйреңіз.",
    foto_link_note: "Фотосуретті жүктеуден басқа, суреттің ашық сілтемесін көрсетуге болады",
    from_account: "Шоттан",
    full_card: "Толық карточка",
    gender: "Жыныс",
    general_info: "Негізгі ақпарат",
    how_to_use: "Қалай пайдалануға болады?",
    hygiene: "Гигиена",
    hygiene_index: "Гигиена индексі",
    iin: "ЖСН",
    importance: "Маңыздылық",
    important: "Маңызды",
    in_chair: "Креслода",
    in_process: "Процесте",
    include_in_f043: "043 нысанды қосу",
    include_in_f043f058: "043 / 058 нысанды қосу",
    include_in_f058: "058 нысанды қосу",
    inn: "ЖСН",
    inspection: "Сыртқы тексеру",
    insurance: "Сақтандыру",
    invoice_print: "Шотты басып шығару",
    is_deleted: "Жойылды",
    issue_date: "Беру күні",
    issued_by: "Кіммен берілді",
    jaws: "Жақтар",
    kpu_index: "КПУ индексі",
    last_visit: "Соңғы келу",
    left_due: "Қалдық",
    life_anamnez: "Өмір анамнезі",
    link: "Сілтеме",
    link_to_call_record: "Сөйлесу жазбасына сілтеме",
    listen: "Тыңдау",
    live_feed: "Жанды таспа",
    lost: "Жоғалды",
    make_payment: "Төлемді жүргізу",
    male: "Ер адам",
    male_short: "Ер адам",
    manual_status: "Қолмен статус",
    medication: "Емдеу",
    middle_name: "Әкесінің аты",
    mkb_code: "МКБ коды",
    move_to_visit: "Келуге өту",
    mphone: "Телефон",
    ndfl_statement: "НДФЛ анықтамасы",
    ndfl_statement_new: "НДФЛ анықтамасы (жаңа)",
    ndfl_statement_xml: "НДФЛ анықтамасы (XML)",
    new: "Жаңа",
    new_patient: "Бастапқы пациент",
    new_patients_automatically_participate_in_bonus_system: "Жаңа пациенттер бонус жүйесіне автоматты түрде қатысады",
    next_visit: "Келесі келу",
    no_attachment: "Жүктеу жоқ",
    no_complexes: "Кешендер жоқ",
    no_teeth_in_the_record: "Жазбада бірде бір тіс көрсетілмеген",
    norm: "Норма",
    not_confirmed: "Расталмаған",
    note: "Ескертпе",
    notes: "Ескертпелер",
    objectively: "Объективті",
    on_week: "Аптаға",
    one_visit_that_came: "Бір сапар аяқталды",
    or_write_other_reason: "немесе басқа себепті көрсетіңіз",
    oral_cavity: "Ауыз қуысы",
    ortodentic_formula: "Ортодонтиялық формула",
    ortodentic_formula_ru: "Ортодонтиялық формула (РФ)",
    other: "Басқа",
    overpayment: "артық төлем",
    paid: "Төленді",
    participate_in_bonus_program: "Бонус жүйесіне қатысады",
    passive: "Пассивті",
    passport: "Паспорт",
    passport_data: "Паспорт деректері",
    passport_number: "Паспорт нөмірі",
    password_validation_error: "Құпия сөздің ұзындығы кемінде 8 таңбадан, ең болмағанда бір бас әріптен, ең болмағанда бір саннан және ең болмағанда бір арнайы таңбадан тұруы тиіс.",
    patient: "Пациент",
    patient_condition_id: "Жағдайы",
    patient_deleted: "Пациент жойылды",
    patient_did_not_come: "Науқас келмеді",
    patient_fio: "Пациенттің ТАӘ",
    patient_has_important_notes: "Пациентте маңызды белгілер: {cnt}",
    patient_number: "Пациент нөмірі",
    patient_phone: "Пациент телефоны",
    patient_source: "қайдан келді",
    patient_with_such_name_exists: "Дерекқорда аты бірдей емделуші әлдеқашан бар",
    payment: "Төлем",
    payment_accepted: "Төлем қабылданды",
    payment_date: "Төлем күні",
    payment_form: "Төлем түрі",
    payment_from: "Төлем",
    payment_history: "Төлем тарихы",
    payment_processing: "Төлем жүргізу",
    payment_type: "Төлем тәсілі",
    payments: "Төлемдер",
    permanent: "Тұрақты",
    permanent_teeth: "Тұрақты тістер",
    permanent_teeth_short: "Тұрақты",
    personal_data: "Дербес деректер",
    pesel: "PESEL",
    phone_2: "Қос. телефон",
    pin: "Бекіту",
    pinned: "Бекітілді",
    plan_fact: "Жоспар / Факт",
    plan_notification: "Хабарлауды жоспарлау",
    planned_result: "Жоспарланған нәтиже",
    planned_send_date: "Жіберудің жоспарланған күні",
    planned_services: "Жоспарланған процедуралар",
    planned_treatment: "Жоспарланған емдеу",
    preliminary: "Алдын ала",
    preliminary_diagnosis: "Алдын ала диагноз",
    price_price: "Прайс",
    prices_price: "Прайстар",
    print_empty: "Мөр толтырылмаған",
    process: "Жүргізу",
    question: "Сұрақ",
    questionnaire: "Сауалнама",
    quick_card: "Жедел карточка",
    receipt: "Түбіртек",
    recommendations: "Ұсыныстар",
    record: "Жазба",
    record_not_available: "Жазба қолжетімді емес",
    recorded: "Жазылды",
    refresh_prices: "Бағаны жаңарту",
    refresh_prices_and_materials: "Баға мен материалдарды жаңарту",
    region: "Аумақ",
    regular_client: "Тұрақты пациент",
    rejected: "Бас тартты",
    reopen_visit: "Қабылдауды қайта ашу",
    representative: "Өкілдің ТАӘ",
    representative_address: "Өкілдің мекенжайы",
    representative_document: "Пациенттің атынан өкілдік ету құқығын куәландыратын құжаттың деректемелері",
    representative_document_number: "Өкіл құжатының нөмірі",
    representative_document_type: "өкіл құжатының түрі",
    representative_id: "Пациенттер тізімінен өкіл",
    representative_inn: "Өкілдің ЖСН",
    representative_noun: "Өкіл",
    representative_passport: "Өкілдің паспортының нөмірі",
    representative_passport_data: "Өкілдің паспорт деректері",
    representative_phone: "Өкілдің телефоны",
    request_snils: "СНИЛС сұрау салу",
    request_snils_note: " ЕГИСЗдан СНИЛС алу - ол үшін пациенттің Т.А.Ә., жынысын, туған күнін және төлқұжат деректерін (типі, сериясы, нөмірі, берілген күні және кім берді) толтыру қажет",
    restore: "Қалпына келтіру",
    result: "Нәтиже",
    results_not_found: "Нәтижелер өткен жоқ",
    results_of_xray_and_lab_research: "Рентгендік, зертханалық зерттеулердің деректері",
    save_and_close: "Сақтау және жабу",
    save_as_template: "Үлгі ретінде сақтау",
    save_as_treatment_template: "Емдеу үлгісі ретінде сақтау",
    scan: "Сурет",
    scans: "Суреттер",
    select_document_type: "Құжат түрін таңдаңыз",
    select_visit: "Келуді таңдаңыз",
    selected_teeth: "Таңдалған тістер",
    send: "Жіберу",
    send_link_to_patient: "Пациентке сілтемені жіберу",
    send_mail: "Хатты жіберу",
    send_marketing: "Маркетингтік таратылымды жіберу",
    send_message: "Хабарлама жіберу",
    send_notifications: "Хабарламалар жіберу",
    send_password_to_patient: "Пациентке құпия сөзді жіберу",
    send_to_laboratory_via_whatsapp: "WhatsApp арқылы зертхананы жіберу",
    send_to_patient_via_max: "Науқасқа Макс арқылы жіберіңіз",
    send_to_patient_via_messenger: "Пациентке мессенджер арқылы жіберіңіз",
    send_to_patient_via_telegram: "Науқасқа Telegram арқылы жіберіңіз",
    send_to_patient_via_telegram_bot: "Telegram-бот арқылы пациентке жіберу",
    send_to_patient_via_whatsapp: "WhatsApp арқылы пациентке жіберу",
    send_try: "Жіберуге тырысу",
    series: "Серия",
    service: "Қызмет",
    services_payment_from: "Көрсетілген қызметтерді төлеу",
    set_the_amount: "Санын көрсетіңіз",
    short_name: "Қысқаша атауы",
    size: "Өлшем",
    sms_available: "СМС қолжетімді",
    sms_sending: "СМС жіберу",
    snils: "СНИЛС",
    sorting_instructions: "Жолдарды қажетті ретпен орналастыру үшін тінтуірмен сүйреп апарыңыз",
    standard: "Стандарт",
    start_treatment: "Емдеуді бастау",
    start_visit: "Қабылдауды бастау",
    stopped: "Тоқтатылды",
    subjectively: "Субъективті",
    such_patient_already_exists_in_database: "Науқас дерекқорда бұрыннан бар",
    sum_with_discount: "Жеңілдікпен сома",
    superadministrator: "Суперәкімші",
    surname: "Тегі",
    symbols_amount: "Таңбалар саны",
    tags_for_contract: "Ақпаратты автоматты түрде шығаруға арналған тегтер:",
    tags_for_document: "Ақпаратты автоматты түрде шығаруға арналған тегтер:",
    teeth: "Тістер",
    teeth_card: "Тіс картасы",
    teeth_selection_instructions: "<b>бірнеше тістерді</b> таңдау үшін Shift пернесін басып тұрып, қажетті тістерді басыңыз. <b>Жаңа топ</b> үшін Shift пернесін босатып, қайта басып тұрыңыз. <b>Бір тіс</b> қалыпты басу арқылы таңдалады.",
    teeth_vertical_selection_instructions: "<b>Жоғарғы көрініс:</b> тінтуірдің сол жақ түймешігін басып тұрып, тістің қажетті аймақтарына сүйреңіз.",
    termometry: "Термометрия",
    there_were_no_payments: "Төлем әлі болған жоқ",
    this_phone_is_in_system: "Осы нөмір базада бар",
    to_account: "Шотқа",
    to_add_diagnoses_you_need_to_select_teeth: "Диагнозды қосу үшін тісті таңдау қажет",
    to_add_services_you_need_to_select_teeth: "Қызметтерді қосу үшін тістерді таңдау қажет",
    to_pay_with_bonus: "Бонустармен төлем",
    to_whom: "Кімге",
    together_with_tooth_all_the_related_services_and_materials_will_be_deleted: "Тіспен бірге тиісті қызметтер, материалдар мен диагноздар жойылады. Растау керек пе?",
    tonometry: "Тонометрия",
    tooth: "Тіс",
    tooth_formula: "Тіс формуласы",
    tooth_is_assigned: "Тісті алып тастау мүмкін емес - оған қызметтер немесе диагноздар байланыстырылған",
    top_baby_teeth: "Жоғарғы сүт тістері",
    top_jaw: "Жоғары жақ",
    top_molars: "Жоғарғы түбір тістер",
    topic: "Тақырып",
    total_paid: "Барлығы төленді",
    total_paid_for_treatment_plan: "Емдеу жоспары бойынша төленген қызметтер",
    total_services_selected: "Барлығы таңдалған қызметтер",
    total_to_pay: "Төлеуге барлығы",
    total_with_discount: "Жеңілдікпен барлығы",
    transfer_between_patient_accounts: "Пациенттің шоттары арасындағы аударым",
    transfer_whole_amount: "Барлық соманы аудару",
    treating_doctor: "Емдеуші дәрігер",
    treatment: "Емдеу",
    treatment_card: "Емдеу карточкасы",
    treatment_complete: "Емдеу аяқталды",
    treatment_history: "Емдеу тарихы",
    treatment_plan: "Емдеу жоспары",
    treatment_template: "Емдеу үлгісі",
    un: "дана",
    unify: "Біріктіру",
    unify_card: "Карточканы біріктіру",
    unpaid: "Төленбеді",
    unpin: "Есептен шығару",
    upload_date: "Жүктеу күні",
    used_medication: "Қолданылатын дәрілік препараттар",
    user_attached_to_family_account: "Пайдаланушы отбасылық шотқа байланған",
    users_attached_to_user_family_account: "Пайдаланушының отбасылық шотына байланған пациенттер",
    visit: "Келу",
    visit_date: "Келу күні",
    visit_description_doctor: "Дәрігермен келуді сипаттау",
    visit_duration: "Келу ұзақтығы (мин)",
    visit_finished: "Қабылдау аяқталды",
    visit_in_progress: "Қабылдау жүруде",
    visit_started: "Қабылдау басталды",
    visit_time: "Келу уақыты",
    visits: "Келулер",
    waiting: "Күтуде",
    waiting_list: "Күту парағы",
    with_formula: "Формуламен",
    without_payment: "Төлеусіз",
    write_reason: "Себепті көрсетіңіз",
    xray: "Рентген",
    years: "Жыл",
    you_need_to_select_teeth: "Сізге тістерді таңдау керек",
    zipcode: "Пошта индексі"
}
